export const mutations = {
  feedback (state, data) {
    // Dummy mutation. An event handler in the related view will act on this mutation type.
  }
}
